import GuideLayout from '@/pages/shared/GuideLayout';

export default function GuideWBS() {
  return (
    <GuideLayout
      title="プロジェクト管理のWBSとは？作り方とガントチャートとの違い｜”おもいむすび”"
      description="WBS（Work Breakdown Structure）とは、プロジェクトの作業を階層的に分解した構成図です。WBSの作り方、目的、メリット、ガントチャートとの違い、Excelテンプレートについて解説します。"
      keywords="プロジェクト管理 WBS,プロジェクト管理 WBSとは,WBS 作り方,WBS ガントチャート 違い,プロジェクト管理 作業分解"
      canonical="https://omoimusubi.asia/guides/wbs/"
      h1="プロジェクト管理のWBSとは？作り方とガントチャートとの違い"
      subtitle="WBS（Work Breakdown Structure：作業分解構成図）の基本概念、作成手順、ガントチャートとの違いについて詳しく解説します。"
      relatedFeatures={[
        { label: 'AIタスク分解', path: '/features/ai-task-breakdown/' },
        { label: 'AIガントチャート', path: '/features/ai-gantt/' },
      ]}
      relatedGuides={[
        { label: 'WBSとガントチャートの違い', path: '/guides/wbs-and-gantt-chart/' },
        { label: 'ガントチャートとは', path: '/guides/gantt-chart/' },
        { label: 'WBSテンプレート', path: '/templates/wbs/' },
      ]}
    >
      <div className="not-prose mb-8 rounded-xl overflow-hidden border border-background-200/70">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20Japanese%20office%20scene%20a%20Japanese%20business%20professional%20a%20man%20in%20his%2030s%20standing%20in%20front%20of%20a%20whiteboard%20drawing%20a%20hierarchical%20WBS%20Work%20Breakdown%20Structure%20tree%20diagram%20with%20colorful%20markers%20showing%20project%20deliverables%20broken%20down%20into%20smaller%20work%20packages%20natural%20daylight%20through%20large%20windows%20indoor%20plants%20clean%20refreshing%20Japanese%20corporate%20workspace%20atmosphere&width=1200&height=600&seq=guide-wbs-01&orientation=landscape"
          alt="WBSとは - ホワイトボードでWBSの構造を説明するビジネスパーソン"
          className="w-full h-auto"
        />
      </div>
      <section>
        <h2>WBSとは</h2>
        <p>WBS（Work Breakdown Structure）とは、プロジェクトの成果物を作り上げるために必要な作業を階層的に分解し、構造化したものです。プロジェクト全体を小さな管理可能な単位に分解することで、作業の漏れを防ぎ、スケジュールやコストの見積もり精度を高めることができます。</p>
      </section>

      <section>
        <h2>WBSの作り方</h2>
        <ol>
          <li><strong>プロジェクトの最終成果物を特定する</strong>：プロジェクトが達成すべき最終的なゴールを明確にします。</li>
          <li><strong>成果物を分解する</strong>：最終成果物を構成する要素（サブ成果物）に分解します。</li>
          <li><strong>作業レベルまで分解する</strong>：各成果物を作るために必要な具体的な作業（ワークパッケージ）にまで分解します。</li>
          <li><strong>作業の抜け漏れを確認する</strong>：すべての必要な作業が網羅されているか、関係者と確認します。</li>
        </ol>
      </section>

      <section>
        <h2>WBSとガントチャートの違い</h2>
        <p>WBSは「何をするか」を階層的に整理したものであり、ガントチャートは「いつ、どの順番で行うか」を時系列で示したものです。WBSで作業を洗い出した後に、それらの作業をガントチャート上にスケジュールとして配置する、という流れが一般的です。</p>
      </section>
    </GuideLayout>
  );
}